// Accounts Chart Getters

export const getAccountsChartsList = state => {
  return state.accountsChartsList
}

export const getFullAccountsChartsList = state => {
  return state.fullAccountsChartsList
}

export const getAccountsChartInfo = state => {
  return state.accountsChartInfo
}

export const getIncomeStatementStatus = state => {
  return state.incomeStatementStatus
}

export const getCashFlowStatus = state => {
  return state.cashFlowStatus
}

export const getBalanceSheetStatus = state => {
  return state.balanceSheetStatus
}
